/* =========================================================================
   SmartRing — theme.js
   No dependencies. Everything degrades gracefully: with JS off the forms
   still post to Shopify and every link still works.
   ========================================================================= */
(function () {
  'use strict';

  var T = window.theme || {};
  var strings = T.strings || {};
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ------------------------------------------------------------- money -- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var fmt = format || T.moneyFormat || '${{amount}}';

    function defaultTo(n, d) { return n === undefined || n === null ? d : n; }

    function thousands(number, precision, thousand, decimal) {
      precision = defaultTo(precision, 2);
      thousand = defaultTo(thousand, ',');
      decimal = defaultTo(decimal, '.');
      if (isNaN(number) || number === null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousand);
      var cts = parts[1] ? decimal + parts[1] : '';
      return dollars + cts;
    }

    var match = fmt.match(placeholder);
    switch (match && match[1]) {
      case 'amount': value = thousands(cents, 2); break;
      case 'amount_no_decimals': value = thousands(cents, 0); break;
      case 'amount_with_comma_separator': value = thousands(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = thousands(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = thousands(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': value = thousands(cents, 0, ' ', ','); break;
      case 'amount_with_space_separator': value = thousands(cents, 2, ' ', ','); break;
      default: value = thousands(cents, 2);
    }
    return fmt.replace(placeholder, value);
  }
  window.formatMoney = formatMoney;

  /* ------------------------------------------------------------- toast -- */
  var toastEl = $('#Toast');
  var toastTimer;
  function toast(message) {
    if (!toastEl) return;
    toastEl.textContent = message;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2600);
  }

  /* ------------------------------------------------------------ header -- */
  var headerOuter = $('.header-outer');
  if (headerOuter) {
    var onScroll = function () {
      headerOuter.classList.toggle('is-scrolled', window.scrollY > 8);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* -------------------------------------------------- overlays / drawers */
  var scrim = $('#Scrim');
  var openPanels = [];
  var lastFocused = null;

  function lockScroll(on) {
    document.body.style.overflow = on ? 'hidden' : '';
  }

  function openPanel(el) {
    if (!el) return;
    lastFocused = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    if (scrim) scrim.classList.add('is-open');
    lockScroll(true);
    openPanels.push(el);
    var focusable = el.querySelector('button, [href], input, select, textarea');
    if (focusable) setTimeout(function () { focusable.focus(); }, 60);
  }

  function closePanel(el) {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    openPanels = openPanels.filter(function (p) { return p !== el; });
    if (!openPanels.length) {
      if (scrim) scrim.classList.remove('is-open');
      lockScroll(false);
    }
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  }

  function closeAllPanels() {
    openPanels.slice().forEach(closePanel);
  }

  if (scrim) scrim.addEventListener('click', closeAllPanels);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeAllPanels();
      $$('.account__panel.is-open').forEach(function (p) { p.classList.remove('is-open'); });
    }
    /* keep tab focus inside an open drawer */
    if (e.key === 'Tab' && openPanels.length) {
      var panel = openPanels[openPanels.length - 1];
      var items = $$('a[href], button:not([disabled]), input, select, textarea', panel)
        .filter(function (el) { return el.offsetParent !== null; });
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* mobile navigation */
  var burger = $('#Burger');
  var mobileNav = $('#MobileNav');
  if (burger && mobileNav) {
    burger.addEventListener('click', function () {
      var open = mobileNav.classList.contains('is-open');
      burger.setAttribute('aria-expanded', String(!open));
      if (open) closePanel(mobileNav); else openPanel(mobileNav);
    });
    $$('a', mobileNav).forEach(function (a) {
      a.addEventListener('click', function () {
        burger.setAttribute('aria-expanded', 'false');
        closePanel(mobileNav);
      });
    });
  }

  /* account dropdown */
  var acctBtn = $('#AccountBtn');
  var acctPanel = $('#AccountPanel');
  if (acctBtn && acctPanel) {
    acctBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = acctPanel.classList.toggle('is-open');
      acctBtn.setAttribute('aria-expanded', String(open));
    });
    document.addEventListener('click', function (e) {
      if (!acctPanel.contains(e.target) && e.target !== acctBtn) {
        acctPanel.classList.remove('is-open');
        acctBtn.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* ---------------------------------------------------------- cart API -- */
  var drawer = $('#CartDrawer');
  var cartCountEls = $$('[data-cart-count]');

  /* ask the Shopify CDN for the size we actually display */
  function sized(url, width) {
    try {
      var u = new URL(url, window.location.origin);
      u.searchParams.set('width', width);
      return u.toString();
    } catch (e) {
      return url;
    }
  }

  function renderCart(cart) {
    var body = $('#CartDrawerBody');
    var foot = $('#CartDrawerFoot');
    var totalEl = $('#CartDrawerTotal');

    var count = cart ? cart.item_count : 0;
    cartCountEls.forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-visible', count > 0);
    });

    if (!body) return;
    if (!cart || !cart.items.length) {
      body.innerHTML =
        '<div class="cart-empty"><div class="cart-empty__icon">◎</div><p>' +
        (strings.cartEmpty || 'Your cart is empty') + '</p></div>';
      if (foot) foot.hidden = true;
      return;
    }

    body.innerHTML = cart.items.map(function (item) {
      var img = item.image
        ? '<img src="' + sized(item.image, 160) + '" alt="" width="68" height="68" loading="lazy">'
        : '<span aria-hidden="true">◎</span>';
      var variant = item.variant_title && item.variant_title !== 'Default Title'
        ? '<div class="line-item__variant">' + item.variant_title + '</div>' : '';
      return (
        '<div class="line-item" data-key="' + item.key + '">' +
          '<a class="line-item__media" href="' + item.url + '">' + img + '</a>' +
          '<div>' +
            '<a class="line-item__title" href="' + item.url + '">' + item.product_title + '</a>' +
            variant +
            '<div class="qty" style="margin-top:8px">' +
              '<button type="button" data-qty-down aria-label="−">−</button>' +
              '<input type="number" value="' + item.quantity + '" min="0" data-qty-input aria-label="' +
                (strings.quantity || 'Quantity') + '">' +
              '<button type="button" data-qty-up aria-label="+">+</button>' +
            '</div>' +
          '</div>' +
          '<div style="text-align:right">' +
            '<div class="line-item__price">' + formatMoney(item.final_line_price) + '</div>' +
            '<button type="button" class="line-item__remove" data-remove>' +
              (strings.remove || 'Remove') + '</button>' +
          '</div>' +
        '</div>'
      );
    }).join('');

    if (foot) foot.hidden = false;
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
  }

  function fetchCart() {
    return fetch(T.routes.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; })
      .catch(function () { return null; });
  }

  function changeLine(key, quantity) {
    return fetch((T.routes.cartChange || '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); });
  }

  function addToCart(formData, button) {
    var original = button ? button.innerHTML : '';
    if (button) {
      button.disabled = true;
      button.innerHTML = '<span class="btn__spinner"></span>' + (strings.adding || 'Adding…');
    }
    return fetch((T.routes.cartAdd || '/cart/add') + '.js', { method: 'POST', body: formData })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw new Error(err.description || err.message); });
        return r.json();
      })
      .then(function () {
        return fetchCart();
      })
      .then(function () {
        if (button) { button.disabled = false; button.innerHTML = original; }
        if (T.cartDrawer && drawer) openPanel(drawer);
        else toast(strings.added || 'Added to cart');
      })
      .catch(function (err) {
        if (button) { button.disabled = false; button.innerHTML = original; }
        toast(err.message || strings.errorGeneric || 'Something went wrong');
      });
  }

  if (drawer) {
    $$('[data-cart-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openPanel(drawer);
        fetchCart();
      });
    });
    $$('[data-cart-close]', drawer).forEach(function (btn) {
      btn.addEventListener('click', function () { closePanel(drawer); });
    });

    drawer.addEventListener('click', function (e) {
      var row = e.target.closest('.line-item');
      if (!row) return;
      var key = row.dataset.key;
      var input = $('[data-qty-input]', row);
      if (e.target.closest('[data-remove]')) { changeLine(key, 0); }
      else if (e.target.closest('[data-qty-down]')) { changeLine(key, Math.max(0, parseInt(input.value, 10) - 1)); }
      else if (e.target.closest('[data-qty-up]')) { changeLine(key, parseInt(input.value, 10) + 1); }
    });
    drawer.addEventListener('change', function (e) {
      if (!e.target.matches('[data-qty-input]')) return;
      var row = e.target.closest('.line-item');
      changeLine(row.dataset.key, Math.max(0, parseInt(e.target.value, 10) || 0));
    });
  }

  /* ajax add-to-cart on any product form */
  $$('form[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      addToCart(new FormData(form), $('[data-add-button]', form) || $('button[type="submit"]', form));
    });
  });

  fetchCart();

  /* ---------------------------------------------------------- quantity -- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-step]');
    if (!btn) return;
    var wrap = btn.closest('.qty');
    var input = $('input', wrap);
    var step = btn.dataset.qtyStep === 'up' ? 1 : -1;
    var min = parseInt(input.min, 10) || 1;
    input.value = Math.max(min, (parseInt(input.value, 10) || min) + step);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* --------------------------------------------------------- accordions -- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-accordion-btn]');
    if (!btn) return;
    var item = btn.closest('[data-accordion-item]');
    var open = item.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', String(open));
  });

  /* ------------------------------------------------------------ gallery -- */
  $$('[data-gallery]').forEach(function (gallery) {
    var main = $('[data-gallery-main]', gallery);
    if (!main) return;
    $$('[data-gallery-thumb]', gallery).forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        main.src = thumb.dataset.full;
        main.srcset = thumb.dataset.srcset || '';
        main.alt = thumb.dataset.alt || '';
        $$('[data-gallery-thumb]', gallery).forEach(function (t) { t.setAttribute('aria-current', 'false'); });
        thumb.setAttribute('aria-current', 'true');
      });
    });
  });

  /* ----------------------------------------------------- variant picker -- */
  $$('[data-variant-picker]').forEach(function (picker) {
    var dataEl = $('[data-variant-json]', picker);
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var form = picker.closest('form') || $('form[data-product-form]');
    var idInput = form ? $('[name="id"]', form) : null;
    var priceEl = $('[data-price]', picker.closest('[data-product-root]') || document);
    var compareEl = $('[data-price-compare]', picker.closest('[data-product-root]') || document);
    var addBtn = form ? $('[data-add-button]', form) : null;
    var mainImg = $('[data-gallery-main]');

    function selectedOptions() {
      return $$('input[data-option]:checked, select[data-option]', picker).map(function (el) { return el.value; });
    }

    function update() {
      var chosen = selectedOptions();
      var match = variants.filter(function (v) {
        return v.options.every(function (opt, i) { return opt === chosen[i]; });
      })[0];

      $$('[data-option-display]', picker).forEach(function (el) {
        var idx = parseInt(el.dataset.optionDisplay, 10);
        el.textContent = chosen[idx] || '';
      });

      if (!match) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = strings.unavailable || 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = formatMoney(match.price);
      if (compareEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          compareEl.textContent = formatMoney(match.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available
          ? (strings.addToCart || 'Add to cart')
          : (strings.soldOut || 'Sold out');
      }
      if (match.featured_image && mainImg) {
        mainImg.src = match.featured_image.src;
        mainImg.srcset = '';
      }
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    picker.addEventListener('change', update);
    update();
  });

  /* --------------------------------------------------------- sticky buy -- */
  var stickyBuy = $('#StickyBuy');
  var buyAnchor = $('[data-buy-anchor]');
  if (stickyBuy && buyAnchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      stickyBuy.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { rootMargin: '-120px 0px 0px 0px' }).observe(buyAnchor);
    $$('[data-sticky-add]', stickyBuy).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var form = $('form[data-product-form]');
        if (form) addToCart(new FormData(form), btn);
      });
    });
  }

  /* ------------------------------------------------------------ marquee -- */
  $$('[data-marquee]').forEach(function (m) {
    var track = $('.marquee__track', m);
    if (!track || track.dataset.cloned) return;
    track.dataset.cloned = '1';
    track.innerHTML += track.innerHTML; /* seamless loop */
  });

  /* --------------------------------------------------------- reveal on -- */
  var revealEls = $$('.reveal');
  if (revealEls.length && 'IntersectionObserver' in window && !reduceMotion) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    revealEls.forEach(function (el, i) {
      el.style.transitionDelay = Math.min(i % 6, 5) * 55 + 'ms';
      io.observe(el);
    });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ------------------------------------------------ localization forms -- */
  $$('[data-locale-form] select').forEach(function (select) {
    select.addEventListener('change', function () {
      select.closest('form').submit();
    });
  });

  /* ------------------------------------------- theme editor re-binding -- */
  document.addEventListener('shopify:section:load', function (event) {
    var scope = event.target || document;
    $$('.reveal', scope).forEach(function (el) { el.classList.add('is-in'); });
    $$('[data-marquee]', scope).forEach(function (m) {
      var track = $('.marquee__track', m);
      if (track && !track.dataset.cloned) {
        track.dataset.cloned = '1';
        track.innerHTML += track.innerHTML;
      }
    });
  });
})();
